import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../../common/form';

class PECHorizontalColumns extends Form {
	state = {
		data: { label: '' },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		label: Joi.number().required().label('Label'),
	};

	static propTypes = {
		onAdd: PropTypes.func,
	};

	doSubmit = (): void => {
		this.props.onAdd(+this.state.data.label);
		this.setState({ data: { label: '' } });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<h2 className="form-title">Data Sheet Reading (New Axial Value)</h2>

				<div className="container-fluid">
					<div className="row">
						<div className="col">
							{this.renderInput({
								type: 'number',
								name: 'label',
								placeholder: 'Enter New Axial Value',
								label: 'New Axial Value',
							})}
						</div>
						<div className="col">
							{this.renderButton('Add New Axial Value')}
						</div>
					</div>
				</div>

			</form>
		);
	}
}

export default PECHorizontalColumns;
